import React from "react";
import "./OptFormStyles.css";

function optFormEmail({ ...resProps }) {
  return <input className="optform-email" {...resProps} />;
}

export default optFormEmail;
